'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _modal = require('../components/modal/modal.js');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var COOKIE_NAME = 'am-newsletter';
var DEFAULT_INIT_DELAY = 5000;

function init(_ref) {
  var el = _ref.el;

  if (_jsCookie2.default.get(COOKIE_NAME)) return false;

  var initialState = getInitialState(el);
  var modal = new _modal.Modal(el);

  setTimeout(function () {
    modal.onOpen();

    _jsCookie2.default.set(COOKIE_NAME, 'true', {
      expires: 3650
    });
  }, initialState.initDelay);

  // function setupForm () {
  //   els.form.addEventListener('submit', onSubmit)
  // }

  // function onSubmit (e) {
  //   resetForm()

  //   const formData = new FormData(els.form)
  //   const customerEmail = formData.get('contact[email]')

  //   if (isValidEmail(customerEmail)) {
  //     els.validationSuccess.classList.remove(classes.HIDE)
  //     els.submitButton.classList.add(classes.BTN_LOADING)

  //     trackGtag({
  //       eventCategory: initialState.trackingCategory,
  //       eventAction: tracking.ACTION_SUBSCRIBE,
  //     })
  //   } else {
  //     els.validationError.classList.remove(classes.HIDE)
  //     e.preventDefault()
  //   }
  // }

  // function resetForm () {
  //   els.validationSuccess.classList.add(classes.HIDE)
  //   els.validationError.classList.add(classes.HIDE)
  // }
}

function getInitialState(el) {
  return {
    initDelay: el.dataset.initDelay ? parseInt(el.dataset.initDelay) : DEFAULT_INIT_DELAY
  };
}